import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryCards() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          <a href="#category-nav" className="hover:text-primary-600 transition-colors">🔍 热门分类</a>
        </h2>
        <p className="mt-3 text-foreground-500 text-sm md:text-base">国产黑料视频实时追踪，按分类精准吃瓜</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative h-72 md:h-80 rounded-xl overflow-hidden"
          >
            <img
              src={cat.imageUrl}
              alt={`${cat.name} - 黑料视频分类`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-600"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent rounded-xl"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="text-white text-lg md:text-xl font-heading font-bold">{cat.name}</h3>
              <p className="text-white/70 text-sm mt-1.5 line-clamp-2">{cat.description}</p>
              <span className="inline-block mt-3 px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs rounded-full whitespace-nowrap">
                {cat.count} 条爆料
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}